import { fillInTheBlanksBaseExtensionConfig, tipTapFillInTheBlanksBaseExtensions } from '@lessonup/pins-shared';
import { JSONContent, mergeAttributes, Node as TiptapNode } from '@tiptap/core';
import { generateHTML } from '@tiptap/html';
import { compact } from 'lodash';
import React, { useMemo } from 'react';
import { blankNodeCss } from './FillInTheBlanksAreaPinComponent.utils';

interface TiptapViewerFillInTheBlanksProps {
  content: JSONContent;
}

export const FillInTheBlanksTiptapGenerateHtml: React.FC<TiptapViewerFillInTheBlanksProps> = ({ content }) => {
  const contentJson = useMemo(() => {
    if (typeof content === 'string') {
      return JSON.parse(content);
    }
    return content;
  }, [content]);

  const output = useMemo(() => {
    const html = contentJson ? generateHTML(contentJson, fillInTheBlanksGenerateExtensions) : '<p></p>';
    return html;
  }, [contentJson]);
  return <div dangerouslySetInnerHTML={{ __html: output }} />;
};

const fillIntheBlanksExtension = TiptapNode.create({
  ...fillInTheBlanksBaseExtensionConfig,
  renderHTML({ HTMLAttributes }) {
    return [
      'span',
      mergeAttributes(HTMLAttributes, { 'data-type': 'fill-in-the-blanks-word', class: blankNodeCss }),
      0,
    ];
  },
});

const fillInTheBlanksGenerateExtensions = compact([...tipTapFillInTheBlanksBaseExtensions, fillIntheBlanksExtension]);
